const algoliaAppId = '69MA7KQCSW'
const algoliaApiKey = '95a3eec58c625e899bc52cd05f6ccf9f'
const citiesSearchIndex = 'cities_search'
const jobsSearchIndex = 'jobs_search'
const jobsSearchSuggestionsIndex = 'jobs_search_query_suggestions'

export {
  algoliaAppId,
  algoliaApiKey,
  citiesSearchIndex,
  jobsSearchIndex,
  jobsSearchSuggestionsIndex,
}
